import TrainingChecklist from './TrainingChecklist';
import Safeguarding from './Safeguarding';
import Advice from './Advice';
import Qualities from './Qualities';

export default { TrainingChecklist, Safeguarding, Advice, Qualities };
